import { combineReducers, Reducer } from 'redux'
import { chifamReducer } from './Chifam/store/reducers'
import { chifamSagas } from './Chifam/store/sagas'

export const modulesSagas = [...chifamSagas]

interface IModulesState {
  Chifam: ReturnType<typeof chifamReducer>
  trust: any
}

export type StaticModulesState = IModulesState

export const modulesReducer: Reducer<any> = combineReducers({
  Chifam: chifamReducer
})
